import React, { Fragment, memo, useCallback, useState } from 'react'
import { CirclePlusMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { colors } from 'src/theme'
import { AssignContractorsModal } from './AssignContractorsModal'

interface Props {
  refreshLinkedContractors(): void
  selectedMCCustomerId: string
}

const LinkContractorsButtonComponent = ({
  refreshLinkedContractors,
  selectedMCCustomerId,
}: Props) => {
  const [isAssignContractorsOpen, setIsAssignContractorsOpen] = useState(false)

  const openAssignContractors = useCallback(() => {
    setIsAssignContractorsOpen(true)
  }, [])

  const closeAssignContractors = useCallback(() => {
    setIsAssignContractorsOpen(false)
  }, [])

  return (
    <Fragment>
      <Button
        color="dark"
        size="small"
        leftIcon={<CirclePlusMinor width={20} height={20} fill={colors.BASICS_WHITE} />}
        onClick={openAssignContractors}
        data-testid="link-customer-main-link-contractors-btn"
      >
        Link contractor(s)
      </Button>
      <AssignContractorsModal
        isAssignContractorsOpen={isAssignContractorsOpen}
        closeAssignContractors={closeAssignContractors}
        refreshLinkedContractors={refreshLinkedContractors}
        selectedMCCustomerId={selectedMCCustomerId}
      />
    </Fragment>
  )
}

export const LinkContractorsButton = memo(LinkContractorsButtonComponent)
